export enum Cy_Certifikaty {
  title = 'certifikaty-title',

  selectFO = 'fyzickaOsobaOption',
  selectPO = 'pravnickaOsobaOption',

  majitelCertifikatuTab = 'majitel-certifikatu-tab',
  specifikaceCertifikatuTab = 'specifikace-certifikatu-tab',
  duvodVyhledavaniCertifikatuTab = 'duvod-vyhledavani-certifikatu-tab',

  jmeno = 'jmeno',
  prijmeni = 'prijmeni',
  typ = 'typ',
  cislo = 'cislo',
  datumNarozeni = 'datumNarozeni',
  // nazev = 'nazev', DIAREZA-1881
  ico = 'ico',
  identifikatorCertifikatu = 'identifikatorCertifikatu',
  serioveCislo = 'serioveCislo',
  platnostRegistraceOd = 'platnostRegistraceOd',
  platnostRegistraceDo = 'platnostRegistraceDo',
  platnostOd = 'platnostOd',
  platnostDo = 'platnostDo',
  status = 'status',
  duvodUcel = 'duvodUcel',

  search = 'certifikaty-search-button',
  clear = 'certifikaty-clear-filter-button',

  table = 'certifikaty-table',
  form = 'certifikaty-form',

  actionButton = 'certifikaty-action-button',

  /**
   * Detail
   */
  downloadPdf = 'certifikaty-download-pdf',

  registraceTable = 'registrace-table',
  majitelTable = 'majitel-table',
  certifikatTable = 'certifikat-table',
}

// readonly Cy_Certifikaty = Cy_Certifikaty;
// [attr.data-cy]="Cy_Certifikaty.title"
